module.exports = __webpack_public_path__ + "static/media/ic_resize.0f268610.svg";